<template>
  <b-modal
    :visible="isQuestionModalOpen"
    centered
    lazy
    @hide="hide"
    hide-footer
  >
    <template slot="modal-header">
      <div class="container text-center w-100 mt-2">
        <h5 class="fa fa-times float-right" @click="hide" />
        <h5>{{ $t('MODAL_askPhysio_question') }}</h5>
      </div>
    </template>

    <!-- View for the User -->
    <template v-if="isLoggedIn">
      <div class="row">
        <div class="col">
          <b-form-input
            type="text"
            name="user"
            id="id_user"
            aria-describedby="username"
            :value="`${user.firstName} ${user.lastName}`"
            disabled
          />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col">
          <b-form-textarea
            :disabled="pending || success"
            type="text"
            name="question"
            id="id_question"
            aria-describedby="question"
            :rows="3"
            :placeholder="$t('MODAL_askPhysio_question')"
            v-model="question"
            required
          />
        </div>
      </div>
      <b-row>
        <b-col class="mt-4">
          {{
            success
              ? $t('MODAL_askPhysios_extra_thanks')
              : $t('MODAL_askPhysios_extra')
          }}
        </b-col>
      </b-row>
      <div class="row mt-4">
        <div class="col">
          <b-button
            v-if="success"
            @click="hide"
            type="submit"
            variant="outline-secondary"
            class="w-100"
            >{{ $t('MODAL_askPhysios_close') }}</b-button
          >
          <b-button
            v-else
            :disabled="pending"
            @click="ask"
            type="submit"
            variant="primary"
            class="w-100"
          >
            <span v-if="pending"> <loader /> </span>
            <span v-else>{{ $t('MODAL_askPhysios_submitQustion') }}</span>
          </b-button>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="row">
        <img src="../../assets/questions.svg" class="mx-auto image" />
      </div>
      <div class="row">
        <div class="col px-5 py-4 text-center">
          <p>{{ $t('MODAL_askPhysios_login_hint') }}</p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col text-center">
          <b-button
            variant="primary"
            @click="$store.dispatch('openLoginModal')"
            >{{ $t('login') }}</b-button
          >
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import Loader from '@/components/Loader';

export default {
  name: 'questionModal',
  components: { Loader },
  computed: {
    ...mapState(['isQuestionModalOpen']),
    ...mapGetters(['isLoggedIn', 'user']),
    ...mapState({
      pending: state => state.api.pending.askPhysio,
      error: state => state.api.error.askPhysio,
      success: state => Boolean(state.api.askPhysio),
    }),
  },
  data() {
    return {
      question: '',
      email: '',
      name: '',
    };
  },
  watch: {
    isQuestionModalOpen: function(newValue) {
      if (!newValue) this.reset();
    },
  },
  methods: {
    ask() {
      this.$store.dispatch('askPhysio', {
        question: this.question,
        email: this.email,
        name: this.name,
      });
    },
    reset() {
      this.name = '';
      this.email = '';
      this.question = '';
    },
    hide() {
      this.$store.dispatch('closeQuestionModal');
    },
  },
};
</script>

<style scoped>
.image {
  width: 125px;
  height: 125px;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/Question.vue